export default __webpack_public_path__ + "static/media/icon-big-fatture-88-px.e13de872.svg";